import { tokenSubTypes, tokenTypes } from '../Constants.js';
import Factory from './Factory.js';
export default {
  type: 'ExpressionField.Root',
  tokenize: (mdl, context) => {
    const toReturn = [];
    mdl.fields.forEach(field => toReturn.push(...Factory.create(field, context)));
    if (Array.isArray(mdl.commaLocations)) {
      toReturn.push(...mdl.commaLocations.map(commaLocation => ({
        startIndex: commaLocation.absolute,
        endIndex: commaLocation.absolute + 1,
        type: tokenTypes.DELIMITER,
        subType: tokenSubTypes.COMMA
      })));
    }
    return toReturn;
  }
};